import { DateTime } from 'luxon';

export const timeAgo = (date?: string): string => {
  if (!date) return '';
  return DateTime.fromISO(date).toLocal().toRelative() || '';
};
